import React, { useState } from "react";
import { Upload, message, Spin, Button } from "antd";
import { InboxOutlined, ArrowLeftOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

const { Dragger } = Upload;

const NgoDocuments = () => {
  const [document1, setDocument1] = useState(null);
  const [document2, setDocument2] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [uploadSuccess1, setUploadSuccess1] = useState(false);
  const [uploadSuccess2, setUploadSuccess2] = useState(false);
  const [document1Data, setDocument1Data] = useState({});
  const [document2Data, setDocument2Data] = useState({});

  const navigate = useNavigate();

  const customUpload = async (info, documentSetter, uploadFunction) => {
    const { file } = info;
    documentSetter(file.originFileObj || file);
    message.success(`${file.name} file prepared for upload.`);
    await uploadFunction(file.originFileObj || file);
  };

  const uploadDocument = async (file, setLoading, setUploadSuccess, setDocumentData) => {
    setLoading(true);
    const token = Cookies.get("jwtToken");
    const filename = file.name;

    try {
      const uploadResponse = await axios.post(
        `${import.meta.env.VITE_API_URL}/upload/private_documents`,
        { filename },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { url, key, timestamp } = uploadResponse.data;

      const s3UploadResponse = await fetch(url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (s3UploadResponse.ok) {
        message.success("Document uploaded successfully!");
        setUploadSuccess(true);
        setDocumentData({ url, key, timestamp });
      } else {
        throw new Error("Failed to upload file to S3");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      message.error("An error occurred while uploading the document.");
      setUploadSuccess(false);
    }
    setLoading(false);
  };

  const proceed = async () => {
    const payload = {
      document: {
        bank_statement: [document2Data],
        id_proof: [document1Data],
      },
    };

    try {
      const response = await axios.patch(`${import.meta.env.VITE_API_URL}/charity`, payload);

      if (response.status === 200) {
        message.success("Documents submitted successfully!");
        navigate("/");
      } else {
        message.error("Failed to submit documents: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error submitting documents:", error);
      message.error("An error occurred while submitting the documents.");
    }
  };

  const signOut = () => {
    Cookies.remove("jwtToken");
    navigate("/");
  };

  return (
    <div className="flex flex-wrap lg:flex-nowrap">
      <div
        className="lg:h-screen h-1/2 lg:w-3/5 lg:absolute bg-cover bg-center lg:block"
        style={{
          backgroundImage:
            'url("https://d1irs7zslorh1g.cloudfront.net/assets/slider/hands-cupping-heart-love-modified.jpg")',
        }}
      ></div>
      <div className="h-[95vh] lg:relative lg:z-10 lg:ml-[770px] w-full lg:w-2/5 mt-4 bg-white border rounded-[20px] -ml-1 overflow-auto">
        <div className="sticky top-0 z-10 flex justify-between items-center bg-white p-10 w-auto shadow-md">
          <Button
            className="flex items-center text-gray-600"
            onClick={() => navigate(-1)}
          >
            <ArrowLeftOutlined /> Back
          </Button>
          <Button className="flex items-center text-gray-600" onClick={signOut}>
            <LogoutOutlined /> Logout
          </Button>
        </div>
        <div className="space-y-4 mt-8 p-4">
        <div className="modal-header bg-btn-1 p-4 text-center sm:text-left rounded-lg">
          <h2 className="text-3xl font-semibold text-center mb-6">Document Submission</h2>
          <p className="text-sm text-gray-600 text-center mb-8">
            To proceed with your application, we require your ID proof and a recent bank statement.
            Please upload them below.
          </p>
          </div>
          <div className="mb-4">
            <h3 className="text-blue-500 py-4">1. ID Proof Submission</h3>
            <Dragger
              name="file"
              multiple={false}
              beforeUpload={() => false}
              onChange={(info) =>
                customUpload(info, setDocument1, (file) =>
                  uploadDocument(file, setLoading1, setUploadSuccess1, setDocument1Data)
                )
              }
              accept=".pdf,.doc"
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
              <p className="ant-upload-hint">
                Only single file upload is allowed. Ensure no company data is included.
              </p>
            </Dragger>
            {loading1 && <Spin className="text-blue-500" />}
          </div>
          <div className="mb-4">
            <h3 className="text-blue-500 py-4">2. Bank Statement Submission</h3>
            <Dragger
              name="file"
              multiple={false}
              beforeUpload={() => false}
              onChange={(info) =>
                customUpload(info, setDocument2, (file) =>
                  uploadDocument(file, setLoading2, setUploadSuccess2, setDocument2Data)
                )
              }
              accept=".pdf,.doc"
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
              <p className="ant-upload-hint">
                Only single file upload is allowed. Ensure no company data is included.
              </p>
            </Dragger>
            {loading2 && <Spin className="text-blue-500" />}
          </div>
          <div className="flex justify-center">
            <Button
              onClick={proceed}
              className={`mt-4 py-2 px-4 text-white rounded-xl transition duration-300 min-w-[160px] ${
                uploadSuccess1 && uploadSuccess2
                  ? "bg-blue-500 hover:bg-blue-700"
                  : "bg-gray-500 cursor-not-allowed"
              }`}
              disabled={!uploadSuccess1 || !uploadSuccess2}
            >
              Proceed
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NgoDocuments;
